var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1797 1.30175C13.6133 0.73527 12.6976 0.73527 12.1312 1.30175L7.60473 5.83177L3.07472 1.30175C2.50824 0.733489 1.5944 0.73527 1.02971 1.30175C0.461451 1.86644 0.461451 2.78028 1.02971 3.34498L5.55793 7.875L1.02971 12.405C0.461451 12.9715 0.461451 13.8853 1.02971 14.45C1.5944 15.0183 2.50824 15.0183 3.07472 14.45L7.60473 9.92179L12.1312 14.45C12.6976 15.0165 13.6133 15.0183 14.1797 14.45C14.7462 13.8853 14.7444 12.9697 14.1797 12.4032L9.65152 7.875L14.1797 3.34854C14.7444 2.78206 14.7462 1.86644 14.1797 1.30175Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.1abedba0e0790a1095de02bbccb4f644.svg";
export { ForwardRef as ReactComponent };